// src/components/customer/CustomerDetailModal.jsx
import { X, Shield, Phone, MapPin, MessageCircle, Users, Star, Home } from 'lucide-react';
import Button from '../layout/ui/Button';
import RatingDisplay from '../common/RatingDisplay';

export default function CustomerDetailModal({ customer, isOpen, onClose }) {
  if (!isOpen || !customer) return null;

  const getPhotoUrl = (path) => {
    if (!path) return null;
    return `${process.env.REACT_APP_IMAGE_URL}${path}`;
  };

  const photoUrl = getPhotoUrl(customer.profile_picture);

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/70 z-50" onClick={onClose} />

      {/* Modal */}
      <div className="fixed inset-4 md:inset-8 lg:inset-auto lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 z-50">
        <div className="bg-white rounded-3xl shadow-3xl max-w-4xl w-full max-h-[92vh] overflow-y-auto">
          {/* Header */}
          <div className="sticky top-0 bg-white/95 backdrop-blur border-b border-gray-100 px-8 py-6 flex justify-between items-center z-10">
            <h2 className="text-3xl font-black text-gray-900">Customer Profile</h2>
            <button onClick={onClose} className="p-3 hover:bg-gray-100 rounded-xl transition-all">
              <X size={28} className="text-gray-600" />
            </button>
          </div>

          <div className="p-8 lg:p-12">
            {/* Hero */}
            <div className="text-center mb-12">
              <div className="relative inline-block mb-8">
                <div className="w-48 h-48 rounded-3xl overflow-hidden shadow-2xl border-8 border-white">
                  {photoUrl ? (
                    <img src={photoUrl} alt={customer.full_name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white text-8xl font-black">
                      {customer.full_name?.[0] || 'C'}
                    </div>
                  )}
                </div>

                {customer.is_vetted && (
                  <div className="absolute -top-4 -right-4 bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 font-bold">
                    <Shield size={20} />
                    <span className="text-sm">Verified</span>
                  </div>
                )}
              </div>

              <h1 className="text-5xl font-black text-gray-900 mb-3">{customer.full_name}</h1>
              <RatingDisplay rating={customer.rating || 0} size="lg" />

              {/* <p className="text-xl text-gray-700 mt-6 flex items-center justify-center gap-3">
                <Phone size={24} className="text-purple-600" />
                {customer.phone_number}
              </p> */}
            </div>

            {/* Info Grid */}
            <div className="grid md:grid-cols-1 gap-10 mb-12">
              {/* <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                  <Users size={32} />
                  Family Details
                </h3>
                <div className="space-y-4 text-lg">
                  {customer.state_of_origin && (
                    <p className="flex items-center gap-3">
                      <MapPin size={22} className="text-gray-500" />
                      {typeof customer.state_of_origin === 'object' 
                        ? customer.state_of_origin.name 
                        : customer.state_of_origin}
                    </p>
                  )}
                  {customer.children_count !== undefined && (
                    <p className="flex items-center gap-3">
                      <Home size={22} className="text-gray-500" />
                      {customer.children_count} child{customer.children_count !== 1 ? 'ren' : ''}
                    </p>
                  )}
                </div>
              </div> */}

              {/* <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                  <Star size={32} />
                  About
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed italic">
                  {customer.bio || "No bio provided yet."}
                </p>
              </div> */}
            </div>

            {/* Action */}
            {/* <div className="flex justify-center gap-6 pt-8 border-t border-gray-200">
              <Button
                onClick={onClose}
                variant="outline"
                className="px-12 py-5 text-xl font-semibold"
              >
                Close
              </Button>
              <Button
                onClick={() => window.location.href = `/dashboard/messages?with=${customer.id}`}
                className="px-16 py-6 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-black text-2xl rounded-2xl shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all"
              >
                <MessageCircle size={28} className="mr-3" />
                Send Message
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}